import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCopyOutline = function SvgCopyOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H14C15.1046 2 16 2.89544 16 4V8H20C21.1046 8 22 8.89544 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89544 22 8 21.1046 8 20V16H4C2.89544 16 2 15.1046 2 14V4ZM9.5 20C9.5 20.2762 9.72384 20.5 10 20.5H20C20.2762 20.5 20.5 20.2762 20.5 20V10C20.5 9.72384 20.2762 9.5 20 9.5H10C9.72385 9.5 9.5 9.72385 9.5 10V20ZM14.5 8H10C8.89543 8 8 8.89543 8 10V14.5H4C3.72384 14.5 3.5 14.2762 3.5 14V4C3.5 3.72385 3.72385 3.5 4 3.5H14C14.2762 3.5 14.5 3.72384 14.5 4V8Z"
  })));
};

export { SvgCopyOutline as ReactComponent };
//# sourceMappingURL=copy-outline.svg.js.map
